import { render, staticRenderFns } from "./PolicyTableHead.vue?vue&type=template&id=1641f80c&scoped=true&"
import script from "./PolicyTableHead.vue?vue&type=script&lang=js&"
export * from "./PolicyTableHead.vue?vue&type=script&lang=js&"
import style0 from "./PolicyTableHead.vue?vue&type=style&index=0&id=1641f80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1641f80c",
  null
  
)

export default component.exports